import styled from "styled-components";
import { H3, Icon, Message } from "@evergis/ui";

import { StructureControlProps } from "./types";

export const CommonSettingsControls = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const CommonSettingsTitleContainer = styled.div`
  display: flex;
  align-items: flex-end;

  ${H3} {
    margin: 2rem 0 0;
    min-width: 23rem;
    max-width: 23rem;
  }
`;

export const StructureWrapper = styled.div`
  margin: 1.65rem 0 0;
`;

export const StructureControl = styled.div<Partial<StructureControlProps>>`
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  opacity: ${({ partial, disabled }) => (partial || disabled) && 0.4};
  pointer-events: ${({ disabled }) => disabled && "none"};

  &:not(:last-child) {
    margin-right: 1rem;
  }

  ${Icon} {
    color: ${({ active, theme }) => (active ? theme.palette.primary : theme.palette.textSecondary)};
  }
`;

export const StructureMessage = styled(Message)`
  position: relative;
  top: 0.625rem;
  margin-left: 1rem;
  font-size: 0.75rem;
`;
